import { useNavigate } from 'react-router-dom'

import { Link, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export const IntegrationSettingsLink = () => {
  const { marketplaceIntegration } = usePrivateIntegrationsSyncContext()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (!marketplaceIntegration?.datoId) return null

  const integrationSettingsUrl = navigation.discover.marketplace.item.settings.fullPath({
    id: marketplaceIntegration?.datoId,
  })

  return (
    <Link.Touchable onClick={() => navigate(integrationSettingsUrl)}>
      <Text.Normal underlined color="grey800" size="200" weight="medium">
        {i18n.t('integrations.footer.validations_sidepanel_title')}
      </Text.Normal>
    </Link.Touchable>
  )
}
